import useStyles from './useStyles'
import { Checkbox, IconButton, Tooltip } from '@mui/material'
import ModalMenuItem from '../../Modals/ModalMenuItem.jsx'
import GppGoodOutlinedIcon from '@mui/icons-material/GppGoodOutlined'
import GppBadOutlinedIcon from '@mui/icons-material/GppBadOutlined'
import GppMaybeIcon from '@mui/icons-material/GppMaybe'
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined'
import {
  commercialTypesTraduc,
  namesTypesTraduc
} from '../../../../../utils/traducTypes'

function TableItem ({ item, setLoading }) {
  const classes = useStyles()

  const getIconStatus = (code) => {
    switch (code) {
      case 'ACTIVE':
        return (
          <Tooltip title="Activo">
            <IconButton>
              <GppGoodOutlinedIcon className={classes.hoverButton} />
            </IconButton>
          </Tooltip>
        )
      case 'WAITING_VALIDATION':
        return (
          <Tooltip title={'Esperando validación'}>
            <IconButton>
              <HelpOutlineOutlinedIcon className={classes.hoverButton} />
            </IconButton>
          </Tooltip>
        )
      case 'BLOCKED':
        return (
          <Tooltip title={'Bloqueado'}>
            <IconButton>
              <GppBadOutlinedIcon className={classes.hoverButtonDelete} />
            </IconButton>
          </Tooltip>
        )
      case 'INACTIVE':
        return (
          <Tooltip title={'Inactivo'}>
            <IconButton>
              <GppBadOutlinedIcon className={classes.hoverButtonDelete} />
            </IconButton>
          </Tooltip>
        )
      // no funciona
      case 'SUSPENDED':
        return (
          <Tooltip title={'Suspendido'}>
            <IconButton>
              <GppMaybeIcon className={classes.hoverButtonDelete} />
            </IconButton>
          </Tooltip>
        )

      default:
        return (
          <Tooltip title={code}>
            <IconButton>
              <GppBadOutlinedIcon className={classes.hoverButtonDelete} />
            </IconButton>
          </Tooltip>
        )
    }
  }

  function traducName (code) {
    let name = null
    namesTypesTraduc.map((typeTraduc) => {
      if (typeTraduc.code === code) {
        name = typeTraduc.name
      }
      return name
    })
    return name
  }
  const traducSpanishCommercialTypes = (type) => {
    const nameTraduc = commercialTypesTraduc.filter(
      (item) => item.code === type
    )
    return nameTraduc.length > 0 ? nameTraduc[0].name : null
  }
  return (
    <>
      <tr className={classes.row}>
        <td className={classes.itemCheck}>
          <Checkbox />
        </td>
        <td className={classes.itemIcon}>
          {getIconStatus(item.user?.status?.userStatusCode)}
        </td>
        {/* <td className={classes.itemEmail}>{item.email}</td> */}

        <td className={classes.itemName}>
          {item.user?.account?.firstName || '- -'}{' '}
          {item.user?.account?.lastName || '- -'}
        </td>
        <td className={classes.itemTypeUser}>
          {traducName(item.user?.type?.organizationUserTypeCode) || '- -'}
        </td>
        {/* <td className={classes.itemDate}>
          {' '}
          {formatDate(item.startDate)
            ? formatDate(item.startDate)
            : 'Fecha no definida'}{' '}
          /{' '}
          {formatDate(item.finishDate)
            ? formatDate(item.finishDate)
            : 'Fecha no definida'}
        </td> */}

        <td className={classes.itemTypeComercial}>
          {traducSpanishCommercialTypes(
            item.user?.commercialType?.organizationCommercialUserTypeCode
          ) || '- -'}
        </td>
        <td className={classes.itemKebab}>
          <ModalMenuItem item={item} setLoading={setLoading} />
        </td>
      </tr>
    </>
  )
}

export default TableItem
